import {
  Dialog,
  DialogContent,
  Slider,
  Tooltip,
  Typography,
} from '@mui/material';
import React, { useState } from 'react';
// 複数
import LibraryAddIcon from '@mui/icons-material/LibraryAdd';
// 単件
import AddBoxIcon from '@mui/icons-material/AddBox';
// カードビュー
import ViewTimelineIcon from '@mui/icons-material/ViewTimeline';
// グリッドビュー
import GridViewIcon from '@mui/icons-material/GridView';
import classes from './HeaderMenu.module.scss';
import { Link, useNavigate } from 'react-router-dom';
import SelectBoxForString from '../atoms/selectboxes/SelectBoxForString';
import { userState } from '../../../states/userState';
import { useRecoilState } from 'recoil';
import { zoomState } from '../../../states/zoomState';
import { User } from '../../../types';
import { setUserToLocalStorage } from '../../../utils/functions/localStorageManager';
import { zooms } from '../../../utils/variables/zoomList';
const HeaderMenu = () => {
  const navigation = useNavigate();
  const [user, setUser] = useRecoilState(userState);
  const [zoom, setZoom] = useRecoilState(zoomState);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const handleZoomClick = () => {
    setIsDialogOpen(true);
  };

  const handleDialogClose = () => {
    setIsDialogOpen(false);
  };

  const handleSliderChange = (event: Event, newValue: number | number[]) => {
    setZoom(String(newValue));
    setUser((prevUser: User) => {
      const newUser: User = {
        ...prevUser,
        initialParameters: {
          ...prevUser.initialParameters,
          zoomLevel: String(newValue),
        },
      };
      setUserToLocalStorage(newUser);
      return newUser;
    });
  };

  return (
    <>
      <div className={classes.iconButton} onClick={() => navigation('/')}>
        <Tooltip title="カードビュー" placement="bottom">
          <ViewTimelineIcon />
        </Tooltip>
      </div>
      <div className={classes.iconButton} onClick={() => navigation('/matrix')}>
        <Tooltip title="グリッドビュー" placement="bottom">
          <GridViewIcon />
        </Tooltip>
      </div>
      <div
        className={classes.iconButton}
        onClick={() => navigation('/singleInput')}
      >
        <Tooltip title="単件登録" placement="bottom">
          <AddBoxIcon />
        </Tooltip>
      </div>
      <div
        className={classes.iconButton}
        onClick={() => navigation('/multiInput')}
      >
        <Tooltip title="一括登録" placement="bottom">
          <LibraryAddIcon />
        </Tooltip>
      </div>
      <div className={classes.zoomDisplay} onClick={handleZoomClick}>
        <SelectBoxForString
          label={''}
          options={zooms}
          required={true}
          select={(e) => {
            setZoom(String(e));
            setUser((prevUser: User) => {
              const newUser: User = {
                ...prevUser,
                initialParameters: {
                  ...prevUser.initialParameters,
                  zoomLevel: String(e),
                },
              };
              setUserToLocalStorage(newUser);
              return newUser;
            });
          }}
          value={zoom}
          disabled={false}
          width={'70px'}
          height={'32px'}
          fontSize={'12px'}
          setMode={'input'}
          colorMode={'dark'}
          readOnly={true}
        />
      </div>
      {/* ズームスライダーダイアログ */}
      <Dialog
        open={isDialogOpen}
        onClose={handleDialogClose}
        BackdropProps={{
          style: { backgroundColor: 'rgba(0, 0, 0, 0.2)' },
        }}
      >
        {/* <DialogTitle>ズーム設定</DialogTitle> */}
        <DialogContent
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Typography gutterBottom>
            ズームレベル: {`${Math.round(Number(zoom) * 100)}%`}
          </Typography>
          <Slider
            value={Number(zoom)}
            min={0.6}
            max={1}
            step={0.05}
            onChange={handleSliderChange}
            aria-labelledby="zoom-slider"
          />
          <div className={classes.zoomDisplay} onClick={handleZoomClick}>
            <SelectBoxForString
              label={''}
              options={zooms}
              required={true}
              select={(e) => {
                setZoom(String(e));
                setUser((prevUser: User) => {
                  const newUser: User = {
                    ...prevUser,
                    initialParameters: {
                      ...prevUser.initialParameters,
                      zoomLevel: String(e),
                    },
                  };
                  setUserToLocalStorage(newUser);
                  return newUser;
                });
              }}
              value={zoom}
              disabled={false}
              width={'70px'}
              height={'32px'}
              fontSize={'12px'}
              setMode={'input'}
              colorMode={'dark'}
              readOnly={false}
            />
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default HeaderMenu;
